export default {
    
    /**
     * Call to the back for getting notification metadata
     * 
     * @return {promise}
     */
    getSettingsMetadata() {
        return new Promise((resolve, reject) => {
            ApiClient.get(`/notifications/metadata`, {})
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err);
                })
        })
    },

    /**
     * Call to the back for getting notification settings
     * 
     * @return {promise}
     */
     getNotificationsSettings() {
        return new Promise((resolve, reject) => {
            ApiClient.get(`/notifications/settings`, {})
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err);
                })
        })
    },

    /**
     * Call to the back to update notification settings
     * 
     * @param {*} params to pass in query
     * @return {promise}
     */
     updateNotificationsSettings(params = {}) {
        return new Promise((resolve, reject) => {
            ApiClient.put(`/notifications/settings`, {}, params)
                .then(res => {
                    resolve(res)
                })
                .catch(err => {
                    reject(err);
                })
        })
    },
    
}